//const locationObject = [{city:'Faridabad sector-48'},{city:'Faridabad sector-49'}, {city: 'Faridabad sector-21'}]
const citiesWeServe = [/*{city:'Amritsar'},{city:'Bangalore'},{city:'Chennai'},{city:'Faridabad'},{city:'Gaya'},{city:'Hazaribag'},{city:'Hyderabad'},{city:'Jaipur'},{city:'Jamshedpur'},{city:'kanpur'},{city: 'Kolkata'},{city:'Lucknow'},*/{city:'Mumbai'}/*,{city:'Mira Road'},{city:'Nagpur'},{city:'New Delhi'},{city:'Patna'},{city:'Pune'},{city:'Raipur'}*/]
function Footer() {
  const todayDate = new Date();
  const deliveryDateArray = todayDate.toDateString().split(" ");
  return <div className="mt-5 p-4 bg-dark text-white text-center">
    <p>Cities We Serve</p>
    <>{citiesWeServe.map((data,index)=> {        
        if(citiesWeServe.length-1!==index) return `${data.city} | ` 
        return `${data.city}`       

      })}</><br /><br />

      {/* <p>We Serve on below loctations to delivery in 2 Hours </p>
      <>{locationObject.map((data,index)=> {        
        if(locationObject.length-1!==index) return `${data.city} | ` 
        return `${data.city}`       

      })}</> <br /><br /> */}
      <span>Copyright © 2026-{deliveryDateArray[3]}</span>
    </div>
}
export default Footer;